import { css } from '@emotion/core';
import { tokens, aNormalize } from '@domain-group/fe-brary';
import { designTokenFonts, truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
var _ref = {
  name: "10klw3m",
  styles: "height:100%;"
};
var _ref2 = {
  name: "1l0z8uk",
  styles: "flex-direction:row;"
};
export var container = appearance => /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;position:relative;gap:16px;padding:16px;background:", colors.neutral.surface.default, ";border:1px solid ", colors.neutral.trim.default, ";border-radius:3px;margin-bottom:12px;", appearance === 'vertical' ? _ref : _ref2);
var _ref3 = {
  name: "1l0z8uk",
  styles: "flex-direction:row;"
};
var _ref4 = {
  name: "1rewpdk",
  styles: "width:241px;"
};
var _ref5 = {
  name: "x4dmss",
  styles: "justify-content:space-between;"
};
export var profile = appearance => /*#__PURE__*/css("display:flex;flex-direction:column;", appearance !== 'vertical' && _ref3, " ", appearance === 'tablet' ? _ref4 : _ref5);
var _ref6 = {
  name: "1utijnj",
  styles: "margin-top:0;max-width:192px;margin-left:16px;"
};
var _ref7 = {
  name: "hy7beb",
  styles: "margin-top:0;max-width:220px;margin-left:16px;"
};
var _ref8 = {
  name: "1u8pvn2",
  styles: "padding-bottom:12px;"
};
export var nameDetail = appearance => /*#__PURE__*/css("margin-top:16px;", appearance === 'horizontal' && _ref6, " ", appearance === 'tablet' && _ref7, " ", appearance === 'vertical' && _ref8);
export var name = /*#__PURE__*/css(designTokenFonts.subheading, " ", truncateLines(2), " ", aNormalize, " &::before{position:absolute;top:0;right:0;left:0;bottom:0;z-index:1;content:'';}");